<div>
  <div class="cooking-header" (swipedown)="swipe($event.type)">
    <div class="title">
      <img src="assets/plans/edit-blue.svg" alt="" />

      <p>مقدار و تاریخ</p>
    </div>
    <img src="assets/cookingbook/angle-down.svg" (click)="goBack()" alt="" />
  </div>
  <div>
    <div class="add-food-bottomsheet-input-holder cooking-holder">
      <p class="cooking-unit-text">نام غذا</p>

      <input
        disabled
        type="text"
        [(ngModel)]="foodName"
        placeholder="میزان واحد"
      />
    </div>

    <!-- <div class="add-food-bottomsheet-input-holder cooking-holder">
      <p class="cooking-unit-text">میزان واحد</p>
      <input
        type="text"
        inputmode="decimal"
        (input)="checkActive()"
        [(ngModel)]="amount"
      />
      <div (click)="openChangeUnit()">
        <p>
          {{ selectedRatio?.name }}
        </p>
        <img src="assets/plans/edit-blue.svg" alt="" />
      </div>
    </div> -->
    <div class="twin-input">
      <div>
        <p class="cooking-unit-text">میزان</p>
        <input
          type="text"
          inputmode="decimal"
          (input)="checkActive()"
          [(ngModel)]="amount"
        />
      </div>

      <div>
        <p class="cooking-unit-text">واحد</p>
        <input
          type="text"
          (input)="checkActive()"
          [(ngModel)]="unitDescription"
        />
      </div>
    </div>

    <div class="add-food-bottomsheet-input-holder cooking-holder">
      <p class="cooking-unit-text">توضیحات</p>
      <input type="text" (input)="checkActive()" [(ngModel)]="description" />
    </div>
    <div
      class="add-food-bottomsheet-input-holder cooking-holder"
      (click)="openDate()"
    >
      <p class="cooking-unit-text">تاریخ انقضا</p>
      <input
        type="text"
        disabled
        [(ngModel)]="dateText"
        placeholder="تاریخ انقضا"
      />
    </div>
    <div
      class="button"
      *ngIf="type == 'search'"
      (click)="save()"
      [ngClass]="{ active: isActive }"
    >
      ثبت کنید
    </div>
    <div class="button-edit" *ngIf="type == 'edit'">
      <div class="submit" (click)="update()" [ngClass]="{ active: isActive }">
        ثبت ویرایش
      </div>
      <div class="delete" (click)="delete()">حذف از لیست</div>
    </div>
  </div>
</div>
